<template>
    <div class="d-flex flex-column flex-root" v-loading="loading">
        <div
            class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-signin-on"
            id="kt_login"
        >
            <!--begin::Aside-->
            <div
                class="login-aside d-flex flex-column flex-row-auto"
                style="background-color: #F2C98A;"
            >
                <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
                    <a href="#" class="text-center mb-10">
                        <img
                            src="media/logos/logo-letter-1.png"
                            class="max-h-70px"
                            alt=""
                        />
                    </a>
                </div>
                <div
                    class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
                    :style="{ backgroundImage: `url(${backgroundImage})` }"
                ></div>
            </div>
            <!--begin::Aside-->
            <!--begin::Content-->
            <div
                class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
            >
                <div class="d-flex flex-column-fluid flex-center">
                    <!--begin::Signin-->
                    <div class="login-form login-signin">
                        <div class="pb-13 pt-lg-0 pt-5">
                            <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">回答フォームログイン</h3>
                            <div class="mt-15" v-if="!$route.params.form_child_url && step == 1">
                                <p>本フォームに初めて回答される方は、以下より回答をお願いします。</p>
                                <div @click="$router.push({ name: 'user-form-info-no-check', params:{ tenant: $route.params.tenant, form_url: $route.params.form_url} })" class="btn btn-primary font-weight-bolder font-size-h6 px-15 mr-3 ">
                                    フォームへ移動
                                </div>
                            </div>
                        </div>
                        <div v-if="step == 1">
                            <form class="form" id="kt_login_signin_form" v-on:submit.prevent="submit">
                                <div class="form-group">
                                    <div>
                                        <p>委託先管理システムのID ・PWにてログインをしてください</p>
                                        <p>メールアドレス、パスワードが不明な場合は管理者までご連絡ください。</p>
                                    </div>
                                    <label class="font-size-h6 font-weight-bolder text-dark"><span class="star">*</span>メールアドレス</label>
                                    <div id="example-input-group-1" label="" label-for="example-input-1">
                                        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg" type="text" name="email" ref="email" v-model="form.email" maxlength="200"/>
                                        <div class="error-message" v-if="error.unique_key_value">{{error.unique_key_value[0]}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex justify-content-between mt-n5">
                                        <label class="font-size-h6 font-weight-bolder text-dark pt-5"><span class="star">*</span>パスワード</label>
                                    </div>
                                    <div id="example-input-group-2" label="" label-for="example-input-2">
                                        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg" type="password" name="password" ref="password" maxlength="200" v-model="form.password" autocomplete="off"/>
                                        <div class="error-message" v-if="error.password_value">{{error.password_value[0]}}</div>
                                    </div>
                                </div>
                                <div class="mt-5 mb-5 text-right">
                                <router-link
                                    class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5 cursor-pointer"
                                    id="kt_login_forgot"
                                    :to="routeForgotPassword"
                                    >PW再設定</router-link
                                >
                                </div>
                                <div class="pb-lg-0 pb-5 ">
                                    <button type="submit" ref="kt_login_signin_submit" class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3">ログイン</button>
                                </div>
                                <input type="hidden" name="_csrf" :value="token" />
                            </form>
                        </div>
                        <div v-else>
                            <form id="verify-submit" v-on:submit.prevent="submitVerify">
                                <div class="form-group">
                                    <label class="font-size-h6 font-weight-bolder text-dark"><span class="star">*</span>電話番号に送信された認証コードを入力してください。</label>
                                    <div class="pt-4">
                                        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg" type="text" name="email" ref="email" v-model="form.sns_code" maxlength="6"/>
                                        <div class="error-message" v-if="error.sns_code">{{error.sns_code[0]}}</div>
                                    </div>
                                </div>
                                <div class="mt-5 mb-5 text-right">
                                    <span v-if="countdown!=0">{{ countdown }}秒後に認証コードが再送できます。 </span>
                                    <h3 v-if="countdown==0" :disabled="isButtonDisabled" class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5 cursor-pointer" @click="renewSms">認証コードを再送します。</h3>
                                </div>
                                <div class="pb-lg-0 pb-5 ">
                                    <button :disabled="isButtonDisabledLogin" type="submit" ref="verify-submit" class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3">ログイン</button>
                                </div>
                                <input type="hidden" name="_csrf" :value="token" />
                            </form>
                        </div>

                    </div>
                    <!--end::Signin-->

                </div>
            </div>
            <!--end::Content-->
        </div>
        <my-dialog
            v-on:submit="popup=false"
            v-bind:dialog="popup"
            :closeOnClickModal="false" width="20%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')"
            :showCancelButton="false">
            <template slot="header">
                <div class="textwidget text-center">
                    {{ contentPoopup }}
                </div>
            </template>
        </my-dialog>
    </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import {ENV} from "@/core/config/env";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import routeTenant from "@/core/services/routeTenant.service"

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import apiService from "@/core/services/api.service";

import KTUtil from "@/assets/js/components/util";
import {mapGetters, mapState} from "vuex";
import {LOGINUSER, LOGOUT, CALL_CSRF_TOKEN, getCsrfRandom, getSCRFToken} from "@/core/services/store/auth.module";
import { STATUS_CODE } from "@/core/config/constant";

export default {
    name: "login-user",
    data() {
        return {
            // Remove this dummy login info
            form: {
                email: "",
                password: "",
                sns_code: "",
                session_otp:""
            },
            loading: false,
            errorMessage:"",
            error:{},
            routeForgotPassword:{ name: 'forgot-password'},
            close_popup: 1111111,
            ENV,
            countdown: 0,
            intervalId: null,
            step:1,
            popup: false,
            contentPoopup: "",
            isButtonDisabled: false,
            isButtonDisabledLogin: false
        };
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(["currentUser"]),
        backgroundImage() {
            return (
                process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
            );
        },
        token(){
          return getCsrfRandom()
        }
    },
    mounted() {
    },
    created() {
        this.$store.dispatch(CALL_CSRF_TOKEN);
    },
    methods: {
        showForm(form) {
            this.state = form;
            var form_name = "kt_login_" + form + "_form";
            KTUtil.animateClass(
                KTUtil.getById(form_name),
                "animate__animated animate__backInUp"
            );
        },
        renewSms(){
            if (!this.isButtonDisabled) {
                this.loading = true
                this.isButtonDisabled = true;
                var unique_key_value = this.form.email;
                var password_value = this.form.password;
                const tenant_code = this.$route.params.tenant
                let form_url = this.$route.params.form_url
                let answer_id = this.$route.params.answer_id ? this.$route.params.answer_id : null
                let param = {unique_key_value, password_value, form_url, answer_id,tenant_code}
                apiService.post(`user/auth/renew-code`, param).then(response => {
                    this.loading = false
                    if (response.data.code == 200) {
                        this.form.sns_code=""
                        this.form.session_otp = response.data.data.session
                        this.startCountdown(30)
                        this.notifySuccess('操作が成功しました。')
                    }else if (response.data.code == 404 || response.data.code ==400) {
                        this.notifyError(response.data.data)
                    }else {
                        this.notifyError(response.data.message)
                    }
                }).catch(e => {
                    this.loading = false
                    this.notifyError(e)
                })
                setTimeout(() => {
                    this.isButtonDisabled = false;
                }, 3000); // Thời gian chờ 1 giây (tùy chỉnh theo nhu cầu của bạn)
            }

        },
        submit(){
            if (!this.isButtonDisabledLogin) {
                this.isButtonDisabledLogin = true;
            const tenant_code = this.$route.params.tenant
            this.error = {}
            this.errorMessage = '';
            var unique_key_value = this.form.email;
            var password_value = this.form.password;
            let form_url = this.$route.params.form_url
            let answer_id = this.$route.params.answer_id ? this.$route.params.answer_id : null
            let param = {unique_key_value, password_value, form_url, answer_id,tenant_code}
            // clear existing errors
            this.$store.dispatch(LOGOUT);
            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.add("spinner", "spinner-light", "spinner-right");
            setTimeout(() => {
                // send login request
                apiService.post(`user/auth/login`, param).then(response1 => {
                    let response = response1.data
                        if (response.code == 422){
                            if (response.data && response.data.poopup_err && response.data.poopup_err[0]) {
                                this.popup = true
                                this.contentPoopup = response.data.poopup_err[0]
                            } else
                                this.error = response.data;
                        }
                        if (response.code == 400|| response.code == 404) {
                            this.notifyError(response.message)
                        }
                        if (response.code == 403) {
                            this.$router.push({name: 'reset-password', query: {token: response.data, flag: 1}});
                        }
                        if (response.code == 200){
                            this.step = 2
                            this.form.session_otp = response.data.session
                            this.startCountdown(30)
                        }
                    })
                    .catch((e) => {
                        this.notifyError(e)
                    });

                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 1000);
                setTimeout(() => {
                    this.isButtonDisabledLogin = false;
                }, 1000); // Thời gian chờ 1 giây (tùy chỉnh theo nhu cầu của bạn)
            }

        },
        submitVerify(){
            this.loading = true
            const tenant_code = this.$route.params.tenant
            this.error = {}
            this.errorMessage = '';
            var unique_key_value = this.form.email;
            var password_value = this.form.password;
            let form_url = this.$route.params.form_url
            let sns_code = this.form.sns_code
            let session_otp = this.form.session_otp
            let answer_id = this.$route.params.answer_id ? this.$route.params.answer_id : null
            let param = {unique_key_value, password_value, form_url, answer_id,sns_code,tenant_code,session_otp}
            // send login request
            this.$store
                .dispatch(LOGINUSER, param)
                // go to which page after successfully login
                .then((response) => {
                    this.loading = false
                    if (response.code == 422) {
                        if (response.data && response.data.poopup_err && response.data.poopup_err[0]) {
                            this.popup = true
                            this.contentPoopup = response.data.poopup_err[0]
                        } else
                            this.error = response.data;
                    }
                    if (response.code == 403) {
                        this.$router.push({name: 'reset-password', query: {token: response.data, flag: 1}});
                    }
                    if (response.code == 400) {
                        this.notifyError(response.data)
                    }
                    if (response.data.token) {
                        if (this.$route.params.form_child_url) {
                            if (this.$route.query.date) {
                                this.$router.push({
                                    name: 'user-form-child-info',
                                    params: {
                                        tenant: tenant_code,
                                        form_url: form_url,
                                        answer_id: this.currentUser.id,
                                        form_child_url: this.$route.params.form_child_url
                                    },
                                    query: {date: this.$route.query.date}
                                })
                            } else {
                                this.$router.push({
                                    name: 'user-form-child-info',
                                    params: {
                                        tenant: tenant_code,
                                        form_url: form_url,
                                        answer_id: this.currentUser.id,
                                        form_child_url: this.$route.params.form_child_url
                                    }
                                })
                            }
                        } else {
                            this.$router.push({
                                name: 'user-form-info',
                                params: {tenant: tenant_code, form_url: form_url, answer_id: this.currentUser.id}
                            })
                        }
                    }
                })
                .catch((e) => {
                    this.loading = false
                    this.notifyError(e)
                });

        },
        startCountdown(duration) {
            let timeRemaining = duration;

            this.countdown = this.formatTime(timeRemaining);

            this.intervalId = setInterval(() => {
                timeRemaining--;

                if (timeRemaining < 0) {
                    clearInterval(this.intervalId);
                    this.countdown = 0;
                } else {
                    this.countdown = this.formatTime(timeRemaining);
                }
            }, 1000);
        },
        formatTime(time) {
            const minutes = Math.floor(time / 60);
            const seconds = time % 60;

            return `${seconds < 10 ? '0' : ''}${seconds}`;
            // return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        },

    },
    beforeDestroy() {
        clearInterval(this.intervalId);
        this.countdown = 0;
    }
};
</script>

<style scoped>
.star{
    content: '*';
    color: #F56C6C !important;
    margin-right: 4px;
}
.error-message{
    color: red;
}

</style>
